<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic
          :exCollection="$route.meta.model"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          :doc="doc"
          :shared="true"
          :pid="false"
        >
          <template slot-scope="{ saveExercise }">
            <div class="relative">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2
                    class="headline"
                    v-text="$t(`${$route.meta.content}.step1.title`)"
                  ></h2>
                </v-col>

                <v-col cols="8" class="">
                  <p
                    v-for="(item, index) in $t(
                      `${$route.meta.content}.step1.description`
                    )"
                    :key="index"
                    v-text="item"
                  />
                </v-col>
              </v-row>

              <v-row v-if="doc">
                <v-col cols="4">
                  <v-card
                    height="100%"
                    light
                    :color="$t(`${$route.meta.content}.color-1`)"
                  >
                    <v-card-text>
                      <quadrant-items
                        v-model="doc.matrix.q1"
                        name="matrix.q1"
                        :title="$t(`${$route.meta.content}.col1`)"
                        subtitle=""
                        :isAdmin="isAdmin"
                      ></quadrant-items>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card
                    height="100%"
                    light
                    :color="$t(`${$route.meta.content}.color-2`)"
                  >
                    <v-card-text>
                      <quadrant-items
                        v-model="doc.matrix.q2"
                        name="matrix.q2"
                        :title="$t(`${$route.meta.content}.col2`)"
                        subtitle=""
                        :isAdmin="isAdmin"
                      ></quadrant-items> </v-card-text
                  ></v-card>
                </v-col>
                <v-col cols="4">
                  <v-card
                    height="100%"
                    light
                    :color="$t(`${$route.meta.content}.color-3`)"
                  >
                    <v-card-text>
                      <quadrant-items
                        v-model="doc.matrix.q3"
                        name="matrix.q3"
                        :title="$t(`${$route.meta.content}.col3`)"
                        subtitle=""
                        :isAdmin="isAdmin"
                      ></quadrant-items> </v-card-text
                  ></v-card>
                </v-col>
              </v-row>
            </div>

            <bottom-navigation
              :save="isAdmin"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
            >
            </bottom-navigation>
          </template>
        </exercise-logic>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t(`${$route.meta.content}.saved.title`)"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title
          class="headline"
          v-text="$t(`${$route.meta.content}.saved.title`)"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import { QuadrantItems } from "@/views/user/exercises/quadrant";

export default {
  name: "UserQuadrants",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      listName: "",
      results: {
        items: [],
      },
      doc: {
        matrix: {
          q1: [],
          q2: [],
          q3: [],
        },
      },
      list: [],
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    QuadrantItems,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      // return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
      return true;
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedEx(items) {
      if (items) {
        this.mergeArrays(items.doc);
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    getResults(doc) {
      this.pushToArray(doc.selectedList, "items", "grey lighten-3");
    },
    pushToArray(arr, model, color) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push({
            title: y.title,
            description: y.description,
            color: color,
          });
        });
      }
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value;
        });
      });
    },
    createList() {
      let items = [];
      Object.values(this.doc.matrix).forEach((value) => {
        value.forEach((x) => {
          x.color = "blue lighten-4";
          items.push(x);
        });
      });
      let itemsFromList = [];
      Object.values(this.doc.list).forEach((value) => {
        value.forEach((x) => {
          itemsFromList.push(x);
        });
      });
      let all = [];
      items.forEach((x) => {
        if (!itemsFromList.some((y) => y.title == x.title)) {
          all.push(x);
        }
      });
      this.doc.allItems = all;
    },
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>

<style lang="scss"></style>
